import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "jasbwg"
};
const _hoisted_2 = {
  class: "wapbanner"
};
const _hoisted_3 = {
  id: "banner",
  class: "swiper-container",
  ref: "swiperBanner"
};
const _hoisted_4 = {
  class: "swiper-wrapper"
};
const _hoisted_5 = {
  class: "swiper-slide"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "wapnav"
};
const _hoisted_8 = {
  class: "swiper-container swiper1",
  ref: "swiper1"
};
const _hoisted_9 = {
  class: "swiper-wrapper"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "wapbox"
};
const _hoisted_13 = {
  class: "waptitlebox"
};
const _hoisted_14 = {
  class: "wapnewli"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "wapbox"
};
const _hoisted_17 = {
  class: "waptitlebox"
};
const _hoisted_18 = {
  class: "swiper-container swiper2",
  ref: "swiper2"
};
const _hoisted_19 = {
  class: "swiper-wrapper"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["src", "alt"];
const _hoisted_22 = {
  class: "wapbox wapbox1"
};
const _hoisted_23 = {
  class: "waptitlebox"
};
const _hoisted_24 = {
  class: "swiper-container swiper3",
  ref: "swiper3"
};
const _hoisted_25 = {
  class: "swiper-wrapper"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "wapbox"
};
const _hoisted_29 = {
  class: "waptitlebox"
};
const _hoisted_30 = {
  class: "swiper-container swiper4",
  ref: "swiper4"
};
const _hoisted_31 = {
  class: "swiper-wrapper"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["src", "alt"];
const _hoisted_34 = {
  class: "wapbox culturals"
};
const _hoisted_35 = {
  class: "waptitlebox"
};
const _hoisted_36 = {
  class: "wapspecialbox"
};
const _hoisted_37 = {
  class: "wapspecialli"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["src"];
const _hoisted_40 = {
  class: "txt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.banners, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_6)]);
  }), 256))]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "pagination"
  }, null, -1))], 512)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
    return _createElementVNode("div", {
      class: "swiper-slide",
      onClick: $event => $options.clickTab(n)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: require(`../../assets/images/2-${n - 1}.png`),
      alt: ""
    }, null, 8, _hoisted_11)])], 8, _hoisted_10);
  }), 64))])], 512)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[6] || (_cache[6] = _createElementVNode("h2", null, "文博资讯", -1)), _cache[7] || (_cache[7] = _createElementVNode("span", {
    class: "line"
  }, null, -1)), _createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = $event => $options.toDetail(1556675, '文博资讯', 5414591))
  })]), _createElementVNode("ul", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.news.filter((n, ni) => {
    return ni < 3;
  }), (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.openDetail(5414598, index)
    }, [_createElementVNode("a", null, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.time ? item.time.split(' ')[0] : ''), 1)])], 8, _hoisted_15);
  }), 256))])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[8] || (_cache[8] = _createElementVNode("h2", null, "藏品鉴赏", -1)), _cache[9] || (_cache[9] = _createElementVNode("span", {
    class: "line"
  }, null, -1)), _createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = $event => $options.toDetail('1556700,1556701', '藏品鉴赏', 5414593, 300092))
  })]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collections.filter((c, ci) => {
    return ci < 5;
  }), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      onClick: $event => $options.openDetail(5414619, index, 1556668, 300092)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: item.img,
      alt: item.name
    }, null, 8, _hoisted_21), _createElementVNode("span", null, _toDisplayString(item.name), 1)])], 8, _hoisted_20);
  }), 256))])], 512)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[10] || (_cache[10] = _createElementVNode("h2", null, "陈列展览", -1)), _cache[11] || (_cache[11] = _createElementVNode("span", {
    class: "line"
  }, null, -1)), _createElementVNode("a", {
    onClick: _cache[2] || (_cache[2] = $event => $options.toDetail('1556679,1556676,1556677', '陈列展览', 5414592, 300086))
  })]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.exhibitions.filter((c, ci) => {
    return ci < 5;
  }), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      onClick: $event => $options.openDetail('', index, 1556673, 300085)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_27), _createElementVNode("div", null, _toDisplayString(item.name), 1)])], 8, _hoisted_26);
  }), 256))])], 512)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[12] || (_cache[12] = _createElementVNode("h2", null, "教育", -1)), _cache[13] || (_cache[13] = _createElementVNode("span", {
    class: "line"
  }, null, -1)), _createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $options.toDetail('1739569,1735089,1739458,1717245', '教育', 5414596, 300089))
  })]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.edus.filter((c, ci) => {
    return ci < 5;
  }), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      onClick: $event => $options.openDetail('', index, 1556669, 300085)
    }, [_createElementVNode("a", null, [_createElementVNode("img", {
      src: item.img,
      alt: item.name
    }, null, 8, _hoisted_33), _createElementVNode("div", null, _toDisplayString(item.name), 1)])], 8, _hoisted_32);
  }), 256))])], 512)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_cache[14] || (_cache[14] = _createElementVNode("h2", null, "文创", -1)), _cache[15] || (_cache[15] = _createElementVNode("span", {
    class: "line"
  }, null, -1)), _createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => $options.toDetail(1556675, '文创', 5553833))
  })]), _createElementVNode("div", _hoisted_36, [_createElementVNode("ul", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.culturals, (item, index) => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("a", {
      onClick: $event => $options.openDetail(5553833, index)
    }, [_createElementVNode("img", {
      src: item.img,
      alt: "国之干城——齐长城研习活动（4-6年级）"
    }, null, 8, _hoisted_39), _createElementVNode("div", _hoisted_40, [_createElementVNode("h3", null, _toDisplayString(item.name), 1)])], 8, _hoisted_38)]);
  }), 256))])])]), _cache[16] || (_cache[16] = _createElementVNode("div", {
    class: "wapunder"
  }, [_createElementVNode("i"), _createElementVNode("span", null, "我是有底线的"), _createElementVNode("i")], -1))]);
}